<section class="page">
  <div class="page-hero">
    <div>
      <p class="eyebrow">AI Backend Developer</p>
      <h1>Lars Nikander Frandsen</h1>
      <p class="lead">
        Aarhus based AI Backend developer with a passion for building scalable and efficient systems. I have a strong background in software development, with expertise in Python, .NET, and cloud technologies.
      </p>
      <div class="tag-row">
        <span class="tag">Python</span>
        <span class="tag">.NET</span>
        <span class="tag">Postgres</span>
        <span class="tag">Azure</span>
        <span class="tag">Umbraco</span>
      </div>
    </div>
    <div class="hero-card">
      <h2>Core strengths</h2>
      <ul>
        <li>GenAI development and Integration</li>
        <li>Software architecture and design</li>
        <li>DevOps and automation</li>
        <li>Fast delivery and iteration</li>
      </ul>
    </div>
  </div>

  <div class="grid-2">
    <article class="panel">
      <h3>About</h3>
      <p>
        36 years old, two kids, wife and a cat. Constantly seeking to improve my skills and stay up-to-date with the latest advancements in AI and software development.
      </p>
    </article>
    <article class="panel">
      <h3>Tooling</h3>
      <p>
        Azure AI Stack, OpenAI, MlFlow, Docker, Terraform, PostgreSQL
      </p>
    </article>
    <article class="panel">
      <h3>Principles</h3>
      <p>
        SOLID design, DRY code, YAGNI, KISS, and continuous learning and improvement.
      </p>
    </article>
    <article class="panel">
      <h3>Availability</h3>
      <p>
        Open to full-time positions, part-time and contract work. I am driven by the opportunity to move the field of AI forward and implementing innovative solutions that make a real impact.
      </p>
    </article>
  </div>
</section>
